export enum LoginKeys {
  spErrorCode = 'custom:sp_errorCode',
  spUserToken = 'custom:sp_userToken',
  spEmailHash = 'custom:sp_email_hash',
  spExisting = 'custom: sp_existing',
  invalidSession = 'invalid session',
}